import { render } from "./ChildGrowthRecord.vue?vue&type=template&id=6cabcc89&scoped=true&ts=true"
import script from "./ChildGrowthRecord.vue?vue&type=script&lang=ts"
export * from "./ChildGrowthRecord.vue?vue&type=script&lang=ts"

import "./ChildGrowthRecord.vue?vue&type=style&index=0&id=6cabcc89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cabcc89"]])

export default __exports__